/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable */
var React = require("react");
var IconSVG = /** @class */ (function (_super) {
    tslib_1.__extends(IconSVG, _super);
    function IconSVG() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IconSVG.prototype.render = function () {
        return (React.createElement("svg", tslib_1.__assign({ role: "img", viewBox: "0 0 16 16" }, this.props),
            React.createElement("path", { d: "m7.1001 9.4385v.835l-1.523.436c-.317.09-.577.434-.577.764v.3h3.3-.6 3.3v-.3c0-.33-.26-.674-.577-.764l-1.523-.436v-.835l-.002-.001c.539-.339.902-.974.902-1.701 0-1.084-.806-1.963-1.8-1.963s-1.8.879-1.8 1.963c0 .726.361 1.36.899 1.699zm8.15 4.562h-14.5c-.414 0-.75-.336-.75-.75v-10.5c0-.415.336-.75.75-.75h4.028c.189 0 .372.071.511.201l1.394 1.299h8.567c.414 0 .75.335.75.75v9c0 .414-.336.75-.75.75zm-13.75-1.5h13v-7.5h-8.111c-.19 0-.372-.072-.512-.202l-1.394-1.298h-2.983z" })));
    };
    return IconSVG;
}(React.Component));
exports.IconSVG = IconSVG;